import { Notes } from "@/pages/Dashboard/Structures/Structure/Notes";
import { AlarmDetail } from "@/pages/Dashboard/Alarms/AlarmDetail";

export const sheetRegistry = {
	structureNotes: Notes,
	alarmDetail: AlarmDetail,
};
